import { Constants } from '../../../../../../../constants/redeProto';
import { KpiCard } from '../../../components/KpiCard';
import { classificationColor, protoColors } from '../../../theme/tokens';
import { EMPTY_VALUE, formatInt, formatPct } from '../../../utils/format';
import { InAccreditationSummary } from '../utils';

const { kpis } = Constants.inAccreditation;

interface SummaryKpisProps {
  summary: InAccreditationSummary;
}

export function SummaryKpis({ summary }: SummaryKpisProps): JSX.Element {
  /** Participação no total de pedidos, para dar escala ao valor absoluto. */
  const shareHint = (value: number): string =>
    summary.total === 0
      ? kpis.ofTotal
      : `${formatPct((value / summary.total) * 100, 0)} ${kpis.ofTotal}`;

  const agingValue =
    summary.avgAging == null
      ? EMPTY_VALUE
      : `${formatInt(Math.round(summary.avgAging))} dias`;

  return (
    <>
      <KpiCard
        label={kpis.total}
        value={formatInt(summary.total)}
        hint={kpis.totalHint}
      />
      <KpiCard
        label={kpis.avgAging}
        value={agingValue}
        hint={kpis.avgAgingHint}
        accentColor={protoColors.purple}
      />
      <KpiCard
        label={kpis.juridicoDone}
        value={formatInt(summary.juridicoDone)}
        hint={shareHint(summary.juridicoDone)}
      />
      <KpiCard
        label={kpis.engenhariaDone}
        value={formatInt(summary.engenhariaDone)}
        hint={shareHint(summary.engenhariaDone)}
      />
      <KpiCard
        label={kpis.active}
        value={formatInt(summary.active)}
        hint={shareHint(summary.active)}
        accentColor={classificationColor.healthy}
      />
      <KpiCard
        label={kpis.paying}
        value={formatInt(summary.paying)}
        hint={shareHint(summary.paying)}
      />
      <KpiCard
        label={kpis.abandoned}
        value={formatInt(summary.abandoned)}
        hint={shareHint(summary.abandoned)}
        accentColor={
          summary.abandoned > 0
            ? classificationColor.attention
            : classificationColor.healthy
        }
      />
    </>
  );
}
